(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .directive('mfSensionInfo', mfSensionInfo);

  mfSensionInfo.$inject = ['MobileHelper', '$modal', '$window'];

  function mfSensionInfo(MobileHelper, $modal, $window) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'dashboard/sensionInfo.directive.html',
      scope: {
        sensionInfo: '@mfSensionInfo'
      },
      link: link
    };

    return directive;

    /////////////////

    function link(scope, elem, attr, ctrl) {
      scope.device = (MobileHelper.isMobileDevice() || $window.mfConfig.isIpad) ? 'mobile' : 'other';

      scope.showSensionMessage = function() {
        $modal.open({
          templateUrl: 'modals/modalSensionInfo.html',
          scope: scope
        });
      }
    }
  }

})();
